import { updateVisibleQuestions } from '../actions/app';

const GetIDFromLabel = (questionID, thisLabel, currentState) => {
    const currentQuestion =
        currentState.dynamicLandingReducer.allQuestionaire.filter(
            (thisQ) => thisQ.id === questionID,
        )[0];
    const currentAnswers = currentQuestion?.answers;
    const currentQuestionID = currentAnswers.filter((thisAnswer) => {
        if (thisAnswer.id === thisLabel) return true;
        return false;
    })[0];

    const thisNestedLinks =
        currentState.dynamicLandingReducer.allQuestionaire[0].metaData
            .nestedQuestionLinks;
    const nestedID = thisNestedLinks?.filter((thisNest) => {
        if (thisNest.answerId === currentQuestionID?.id) return true;
        return false;
    })[0];
    return nestedID?.linkedQuestionId;
};

export function formUpdateThunk(updateInfo) {
    return async (dispatch, getState) => {
        const currentState = getState();
        const passedInputValue =
            typeof updateInfo.shieldReturnValue.inputValue !==
            'undefined'
                ? updateInfo.shieldReturnValue.inputValue
                : updateInfo.shieldReturnValue;
        const shallUpdateVisibleList =
            typeof passedInputValue === 'object' || 'string';
        const currentShieldData =
            typeof passedInputValue === 'object'
                ? [...passedInputValue]
                : [passedInputValue];

        let checkedItems = currentShieldData;
        if (typeof passedInputValue === 'object') {
            /// first time, we need to do this manually
            checkedItems = currentShieldData.filter(
                (thisItem) => thisItem.checked === true,
            );
        }
        const matchList = checkedItems
            .map((thisCheckedItem) => {
                const checkType =
                    typeof thisCheckedItem === 'string'
                        ? thisCheckedItem
                        : thisCheckedItem.valid;
                const matchedQuestion = GetIDFromLabel(
                    updateInfo.universalQuestionID,
                    checkType,
                    currentState,
                );
                if (matchedQuestion) return matchedQuestion;
                return null;
            })
            .filter((thisMatch) => !!thisMatch);
        const updatedVisibleID = [
            ...updateInfo.visibleQuestions,
            ...matchList,
        ];

        const visibleQuestion = [...new Set(updatedVisibleID)];
        if (shallUpdateVisibleList)
            dispatch(updateVisibleQuestions(visibleQuestion));
    };
}
